import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Mustache from 'mustache';
/**
 * Component which gets an HTML Template file from a given URL
 *
 * and renders it, passing in the variable set.
 *
 * ```js
 * import { HTMLTemplate } from '@minerva-analytics/pantheon';
 *
 * <HTMLTemplate
 *   templateUrl='www.example.com'
 *   variables={{ foo: 'bar' }}
 * />
 * ```
 */

var HTMLTemplate = function HTMLTemplate(_ref) {
  var templateUrl = _ref.templateUrl,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? {} : _ref$variables;

  var _useState = useState(""),
      template = _useState[0],
      setTemplate = _useState[1];

  useEffect(function () {
    axios.get(templateUrl, {
      timeout: 10000
    }).then(function (res) {
      var html = res.data;
      var output = Mustache.render(html, variables);
      setTemplate(output);
    }).catch(function () {
      return setTemplate("<p> Sorry, an unexpected error has happened. Please try again later. </p>");
    });
  }, [templateUrl]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: template
      }
    })
  );
};

HTMLTemplate.propTypes = {
  /** URL used to fetch HTML template */
  templateUrl: PropTypes.string.isRequired,

  /** Variables used to fill the fetched HTML template */
  variables: PropTypes.object
};
export default HTMLTemplate;